'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();

import type { MenuItemSub } from '@workspace/ui/types';
import { buildWalletNavSubitems, computeHasActiveEntityWallet } from '@workspace/ui/lib';
import { useMemo } from 'react';
import { useAuth } from '@/hooks/use-auth';
import { useCanAccessSalaryWallet } from '@/hooks/use-can-access-salary-wallet';
import { useIsContractor, useIsGigWorker, useIsIndividualCraft } from '@/hooks/use-contractor';
import { useCountries } from '@/hooks/use-countries';
import { useEntities } from '@/hooks/use-entities';
import { useIsEmployee, useIsEmployer } from '@/hooks/use-employer';
import { useUserVerification } from '@/hooks/use-user';
import { useWallets } from '@/hooks/use-wallet';

export function useWalletNavSubitems(): MenuItemSub[] | undefined {
  const { isAuthenticated, accessToken } = useAuth();
  const isEmployer = useIsEmployer();
  const isContractor = useIsContractor();
  const isGigWorker = useIsGigWorker();
  const isIndividualCraft = useIsIndividualCraft();
  const isEmployee = useIsEmployee();
  const hasSalaryWalletAccess = useCanAccessSalaryWallet();

  const { data: userVerification } = useUserVerification(isAuthenticated && !!accessToken);

  const organisationIds = useMemo(
    () => userVerification?.organisations?.map((organisation) => organisation.id),
    [userVerification?.organisations]
  );

  const entityNavEnabled =
    isEmployer && isAuthenticated && !!accessToken && !!organisationIds?.length;

  const { data: countries } = useCountries(entityNavEnabled);
  const { data: entitiesResponse } = useEntities(organisationIds, entityNavEnabled);
  const { data: entityWallets } = useWallets(entityNavEnabled, { walletType: 'entity' });

  const hasActiveEntityWallet = useMemo(
    () =>
      computeHasActiveEntityWallet({
        entities: entitiesResponse?.data,
        countries,
        entityWallets,
      }),
    [countries, entitiesResponse?.data, entityWallets]
  );

  return useMemo(
    () =>
      buildWalletNavSubitems({
        isEmployer,
        isEmployee,
        isContractor,
        isGigWorker,
        isIndividualCraft,
        hasActiveEntityWallet,
        hasSalaryWalletAccess,
      }),
    [
      hasActiveEntityWallet,
      hasSalaryWalletAccess,
      isContractor,
      isEmployee,
      isEmployer,
      isGigWorker,
      isIndividualCraft,
    ]
  );
}
